(function () {
  if (window.QLSCartBadgeMinusProtectionStableTestV61Loaded) return;
  window.QLSCartBadgeMinusProtectionStableTestV61Loaded = true;

  var PROTECTION_MATCHERS = [
    'quality shipping protection',
    'shipping protection',
    'simply shipping protection',
    'route package protection',
    'package protection'
  ];

  /*
    Main timing:
    - 4200ms felt close based on your testing.
    - Raise to 5000 if the number reappears too early.
    - Lower to 3500 if it stays hidden too long.
  */
  var hideAfterCartActionMs = 4200;

  var revealTimer = null;
  var isRefreshing = false;
  var lastCleanCount = null;

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function isProtectionItem(item) {
    if (!item) return false;

    var text = [
      item.title,
      item.product_title,
      item.variant_title,
      item.handle,
      item.url,
      item.sku,
      item.vendor,
      item.product_type
    ].map(normalize).join(' ');

    return PROTECTION_MATCHERS.some(function (matcher) {
      return text.indexOf(matcher) !== -1;
    });
  }

  function shouldExcludeProtectionFromCount() {
    var config = document.querySelector('[data-qls-shipping-protection-config]');
    if (!config) return true;
    return config.dataset.excludeFromCartCount !== 'false';
  }

  function getCleanCartCount(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;

    if (!shouldExcludeProtectionFromCount()) {
      return Number(cart.item_count) || 0;
    }

    return cart.items.reduce(function (total, item) {
      if (isProtectionItem(item)) return total;
      return total + (Number(item.quantity) || 0);
    }, 0);
  }

  function getCartCountNodes() {
    return document.querySelectorAll([
      '.header__cart-count-number',
      '.header__cart-count > span[aria-hidden="true"]',
      '.cart-count-bubble > span[aria-hidden="true"]',
      '.cart-count-bubble > span:not(.visually-hidden)',
      '[data-cart-count]:not(.header__cart-count)',
      '[data-header-cart-count]:not(.header__cart-count)'
    ].join(','));
  }

  function updateCartBadge(count) {
    if (count === null || typeof count === 'undefined') return;

    lastCleanCount = count;

    getCartCountNodes().forEach(function (node) {
      if (!node) return;
      node.textContent = String(count);

      if (node.hasAttribute('data-cart-count')) {
        node.setAttribute('data-cart-count', String(count));
      }

      if (node.hasAttribute('data-header-cart-count')) {
        node.setAttribute('data-header-cart-count', String(count));
      }
    });

    document.querySelectorAll('.header__cart-count, .cart-count-bubble').forEach(function (bubble) {
      if (count <= 0) {
        bubble.classList.add('hidden');
        bubble.setAttribute('aria-hidden', 'true');
      } else {
        bubble.classList.remove('hidden');
        bubble.removeAttribute('aria-hidden');
      }
    });

    document.querySelectorAll('#cart-icon-bubble, #cart-icon, a[href="/cart"], a[href*="/cart"]').forEach(function (cartLink) {
      if (!cartLink) return;
      cartLink.setAttribute('aria-label', count === 1 ? 'Cart, 1 item' : 'Cart, ' + count + ' items');
    });
  }

  function refreshCartCount(callback) {
    if (isRefreshing) {
      if (typeof callback === 'function') {
        window.setTimeout(callback, 150);
      }
      return;
    }

    isRefreshing = true;

    fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Could not load cart');
      return response.json();
    })
    .then(function (cart) {
      updateCartBadge(getCleanCartCount(cart));
    })
    .catch(function () {
      /*
        Quiet fail.
        Never block or break the storefront if cart.js is delayed.
      */
    })
    .finally(function () {
      isRefreshing = false;

      if (typeof callback === 'function') {
        callback();
      }
    });
  }

  function refreshAt(delay) {
    window.setTimeout(function () {
      refreshCartCount();
    }, delay);
  }

  function runHiddenRefreshes() {
    /*
      While the badge number is hidden, keep checking the real cart.
      This silently corrects the count while Shipping Protection updates.
    */
    refreshAt(80);
    refreshAt(300);
    refreshAt(650);
    refreshAt(1000);
    refreshAt(1500);
    refreshAt(2100);
    refreshAt(2800);
    refreshAt(3600);
  }

  function runAfterRevealCorrections() {
    /*
      After showing the badge again, correct quietly in case the app/theme
      rewrites the number right at the end.
    */
    refreshAt(350);
    refreshAt(900);
    refreshAt(1800);
    refreshAt(3000);
  }

  function revealCorrectedBadge() {
    refreshCartCount(function () {
      if (lastCleanCount !== null) {
        updateCartBadge(lastCleanCount);
      }

      document.documentElement.classList.remove('qls-cart-badge-settling');

      /*
        If you are using the early theme.liquid mask, this also releases it
        after the corrected number is ready.
      */
      document.documentElement.classList.add('qls-cart-badge-ready');
      document.documentElement.classList.remove('qls-cart-badge-mask');

      runAfterRevealCorrections();
    });
  }

  function startCartBadgeSettlingCycle() {
    /*
      Hide the number immediately when cart activity starts.
      This prevents the visible count flicker before/during the drawer opening.
    */
    document.documentElement.classList.add('qls-cart-badge-settling');

    /*
      Support either of the two earlier theme.liquid preload-mask approaches.
      This makes the custom block compatible with the version you restored.
    */
    document.documentElement.classList.add('qls-cart-badge-ready');

    window.clearTimeout(revealTimer);

    runHiddenRefreshes();

    revealTimer = window.setTimeout(revealCorrectedBadge, hideAfterCartActionMs);
  }

  function handleLikelyCartActivity() {
    startCartBadgeSettlingCycle();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (
      target.closest('button[name="add"]') ||
      target.closest('.js-atc-btn') ||
      target.closest('[data-atc]') ||
      target.closest('button[name="plus"]') ||
      target.closest('button[name="minus"]') ||
      target.closest('button[name="remove"]') ||
      target.closest('.quantity__button') ||
      target.closest('.cart-item__remove') ||
      target.closest('.cart-remove-button') ||
      target.closest('[data-remove]')
    ) {
      handleLikelyCartActivity();
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;

    if (
      target.matches('form[action*="/cart/add"]') ||
      target.classList.contains('js-product-form') ||
      target.classList.contains('js-product-form-main')
    ) {
      handleLikelyCartActivity();
    }
  }, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;

    if (
      target.matches('input[name="quantity"]') ||
      target.matches('input[type="number"]')
    ) {
      handleLikelyCartActivity();
    }
  }, true);

  document.addEventListener('on:cart:add', handleLikelyCartActivity);
  document.addEventListener('cart:updated', handleLikelyCartActivity);

  document.addEventListener('shopify:section:load', function () {
    refreshCartCount(function () {
      document.documentElement.classList.add('qls-cart-badge-ready');
      document.documentElement.classList.remove('qls-cart-badge-mask');
    });
  });

  /*
    Page load:
    Correct the count as soon as this block loads.
    Your theme.liquid preload mask handles the very early flash.
  */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      refreshCartCount(function () {
        document.documentElement.classList.add('qls-cart-badge-ready');
        document.documentElement.classList.remove('qls-cart-badge-mask');
      });
    });
  } else {
    refreshCartCount(function () {
      document.documentElement.classList.add('qls-cart-badge-ready');
      document.documentElement.classList.remove('qls-cart-badge-mask');
    });
  }
})();
